import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  SIGNOUT_SUCCESS,
  SIGNOUT_FAILED,
  SIGNUP_SUCCESS,
  SIGNUP_FAILED
} from "../actions/types";

const IntialState = {
  authError: null
};

export default (state = IntialState, action) => {
  switch (action.type) {
    case LOGIN_ERROR:
      return {
        ...state,
        authError: "Login Fail",
        errorType: "error"
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        authError: null
      };
    case SIGNOUT_SUCCESS:
      return state;
    case SIGNOUT_FAILED:
      return state;
    case SIGNUP_SUCCESS:
      return {
        ...state,
        authError: null
      };
    case SIGNUP_FAILED:
      return {
        ...state,
        authError: action.err.message
      };
    default:
      return state;
  }
};
